/* import __COLOCATED_TEMPLATE__ from './escalate-if-needed.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: { accordion: $TSFixMe; escalationRulesCount: number };
}

const EscalateIfNeeded = templateOnlyComponent<Signature>();
export default EscalateIfNeeded;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::EscalateIfNeeded': typeof EscalateIfNeeded;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/escalate-if-needed': typeof EscalateIfNeeded;
  }
}
